import angular from 'angular';

function OrderItemAddOnDirective() {
  OrderItemAddOnController.$inject = ['$scope'];
  function OrderItemAddOnController($scope) {
    $scope.orderItemAddOn = 'Your spankin new order.item.addOn!';
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/addOn/addOn.tpl.html',
    scope: {
      model: '=',
      options: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemAddOnController,
  };
}

export const OrderItemAddOnDirectiveModule = angular
  .module('acme.common.directive.order.item.addOn', [])
  .directive('orderItemAddOn', OrderItemAddOnDirective).name;
